import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import MoreHorizontal from '@scope/scope-one-ui/assets/icons/more-horizontal.svg';
import ArrowUpRight from '@scope/scope-one-ui/assets/icons/arrow-up-right.svg';
import { IconTextButton, Box, Typography } from '@scope/scope-one-ui/core';
import { COLORS } from '@scope/scope-one-ui/theme';
import { useNavigate, useLocation } from 'react-router-dom';
import qs from 'qs';
import { ItemsWidgetProps } from './ItemsWidget.d';
import {
  EntitiesTile,
  FundsTile,
  IconWrapper,
  InstrumentsTile,
  ThreeDotsTile,
  TileNumber,
  TileRow,
  WidgetStyled,
} from './PortfolioSummary.styled';

export const ItemsWidget: FC<ItemsWidgetProps> = ({ noOfItems }) => {
  const { t } = useTranslation();
  const { entities, instruments, funds } = noOfItems;
  const navigate = useNavigate();
  const location = useLocation();

  const goToTab = (route: string) => {
    navigate(
      {
        pathname: location.pathname,
        search: qs.stringify({ activeTab: route }, { addQueryPrefix: true }),
      },
      { replace: true },
    );
  };

  return (
    <WidgetStyled title={t('PORTFOLIO.ITEMS')}>
      <TileRow display="flex">
        <EntitiesTile onClick={() => goToTab('entities')}>
          <Box>
            <TileNumber variant="h1">{entities}</TileNumber>
            <Typography variant="subtitle">{t('PORTFOLIO.ENTITIES')}</Typography>
          </Box>
          <IconWrapper>
            <ArrowUpRight />
          </IconWrapper>
        </EntitiesTile>
        <InstrumentsTile onClick={() => goToTab('instruments')}>
          <Box>
            <TileNumber variant="h1">{instruments}</TileNumber>
            <Typography variant="subtitle">{t('PORTFOLIO.INSTRUMENTS')}</Typography>
          </Box>
          <IconWrapper>
            <ArrowUpRight />
          </IconWrapper>
        </InstrumentsTile>
      </TileRow>
      <TileRow display="flex">
        <FundsTile onClick={() => goToTab('funds')}>
          <Box>
            <TileNumber variant="h1">{funds}</TileNumber>
            <Typography variant="subtitle">{t('PORTFOLIO.FUNDS')}</Typography>
          </Box>
          <IconWrapper>
            <ArrowUpRight />
          </IconWrapper>
        </FundsTile>
        <ThreeDotsTile>
          <IconTextButton icon={<MoreHorizontal color={COLORS.typography.main} />} />
        </ThreeDotsTile>
      </TileRow>
    </WidgetStyled>
  );
};

export default ItemsWidget;
